import { useGetLessonProgressNodes } from "hooks/useGetLessonProgressNodes";
import { CircularProgress, Divider, Grid, Stack, Typography, useTheme } from "@mui/material";
import { CompletedNode } from "models/CompletedNode";
import { useTranslation } from "react-i18next";
import SelectedAnswer from "components/views/myTrainings/SelectedAnswer";
import { StyledPaper, StyledCircleIcon } from './LessonProgressNodes.styles';

export const LessonProgressNodes = (props: { lessonProgressId: string, completedNodes: CompletedNode[], isCompleted: boolean }) => {
    const theme = useTheme();
    const { t } = useTranslation();
    const { nodes, gettingNodes } = useGetLessonProgressNodes(props.lessonProgressId);
    const { completedNodes } = props;

    const isChosenAnswer = (nodeId: string, answerId: string) => {
        const completedNode = completedNodes.find(cn => cn.nodeId === nodeId);
        return completedNode?.answerModel?.answerId === answerId;
    }

    return gettingNodes
    ? <CircularProgress />
    : <Stack spacing={theme.spacing(2)}>
        {nodes.map((node, index) =>
        <StyledPaper key={index}>
            <Stack direction={'row'} spacing={2} width={'100%'}>
                <Stack direction={'row'} width='20%' spacing={theme.spacing(2)} display='flex' justifyContent={'center'} alignItems={'center'}>
                    <Stack direction='row' width='30%' justifyContent={'center'}>
                        <StyledCircleIcon />
                    </Stack>
                    <Stack display='flex' flexDirection={'column'} width='70%' justifyContent={'flex-start'} alignContent={'flex-start'}>
                        <Typography fontWeight={'500'}>
                            {node.name}
                        </Typography>
                    </Stack>
                </Stack>
                <Divider orientation="vertical" flexItem />

                <Stack direction={'column'} width={'80%'}>
                    <Typography fontWeight={'700'}>
                        {node.textQuestion}
                    </Typography>
                    <Grid container>
                        {node.textAnswers.map((answer, index) => 
                            <SelectedAnswer
                                answer={answer.answer}
                                index={index}
                                isChosenAnswer={isChosenAnswer(node.id, answer.id)}
                                score={answer.score}
                                key={index}
                            />
                        )}
                        {node.voiceAnswers.map((answer, index) =>
                            <SelectedAnswer
                                answer={answer.keywords}
                                index={index}
                                isChosenAnswer={isChosenAnswer(node.id, answer.id)}
                                score={answer.score}
                                key={index}
                            />
                        )}
                    </Grid>
                </Stack>                   
            </Stack>    
        </StyledPaper>)}
        { !props.isCompleted &&
            <StyledPaper sx={{ paddingTop: theme.spacing(2), paddingBottom: theme.spacing(2)}}>
                <Typography fontWeight={'700'} textAlign={'center'}>
                    {t('myTrainings.historicalProgress.notFinished')}
                </Typography>
            </StyledPaper>
        }
    </Stack>    
}